import { useRuntimeConfig } from '#app'

export const useRedirectApiUrl = (): string => {
  const config = useRuntimeConfig()

  return import.meta.client ? config.public.redirectBaseUrl as string : config.redirectSsrUrl as string
}
